module.exports = __webpack_public_path__ + "img/Secret-Box.f0af8fd1.png";